import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'does_facility_have_fire_detection_alarm_system_place'

export const dataPointDefinition = {
  retracedId: 'does_facility_have_fire_detection_alarm_system_place',
  name: 'Does the facility have a fire detection and alarm system in place, although there are no applicable legal requirements?',
  description: 'You have indicated that there are "No applicable legal requirements". ',
  meta: {
    slcpMeta: {
      key: 'hs-19--3',
      number: 'HS-EME-4',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-19--3', version: '1.7.0', provider: 'slcp'}],
  sortingId: 29200,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
